(()=>{
function mount(root){
 if(root.dataset.mounted)return;
 root.dataset.mounted='1';

 const intro=root.querySelector('[data-intro]');
 const ambient=root.querySelector('[data-ambient]');
 const content=root.querySelector('[data-content]');
 const skip=root.querySelector('[data-skip]');
 const motion=root.querySelector('[data-motion]');
 const replay=root.querySelector('[data-replay]');
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 const controller=new AbortController();
 const signal=controller.signal;
 let introTimer;
 let countdownTimer;
 let introAttempt=0;
 let paused=reduce.matches;
 const on=(el,event,fn)=>el?.addEventListener(event,fn,{signal});

 function motionLabel(){
  if(!motion)return;
  motion.textContent=paused?'Play motion':'Pause motion';
  motion.setAttribute('aria-pressed',String(!paused));
 }

 async function startAmbient(){
  motionLabel();
  if(!ambient||paused||document.hidden||root.classList.contains('is-intro'))return;
  ambient.muted=true;
  ambient.defaultMuted=true;
  ambient.playsInline=true;
  try{
   await ambient.play();
   if(!paused)ambient.classList.add('is-visible');
   else ambient.pause();
  }catch{
   ambient.classList.remove('is-visible');
  }
 }

 function finish(){
  introAttempt++;
  clearTimeout(introTimer);
  intro?.pause();
  root.classList.remove('is-intro');
  root.classList.add('is-ready');
  if(content)content.inert=false;
  if(document.activeElement===skip)replay?.focus();
  if(skip)skip.hidden=true;
  startAmbient();
 }

 async function playIntro(manual=false){
  if(!intro||(!manual&&reduce.matches)){
   finish();
   return;
  }
  const attempt=++introAttempt;
  clearTimeout(introTimer);
  ambient?.pause();
  ambient?.classList.remove('is-visible');
  root.classList.remove('is-ready');
  root.classList.add('is-intro');
  if(content)content.inert=true;
  if(skip)skip.hidden=false;
  intro.muted=true;
  intro.defaultMuted=true;
  intro.playsInline=true;
  intro.currentTime=0;
  if(!intro.currentSrc)intro.load();
  introTimer=setTimeout(finish,11000);
  try{
   await intro.play();
   if(attempt!==introAttempt)intro.pause();
  }catch{
   finish();
  }
 }

 on(intro,'ended',finish);
 on(intro,'error',finish);
 on(skip,'click',finish);
 on(replay,'click',()=>playIntro(true));
 on(root.querySelector('[data-join]'),'click',finish);
 on(motion,'click',()=>{
  paused=!paused;
  if(paused){
   ambient?.pause();
   ambient?.classList.remove('is-visible');
  }else startAmbient();
  motionLabel();
 });
 on(ambient,'error',()=>{
  ambient.classList.remove('is-visible');
  if(motion)motion.hidden=true;
 });
 on(document,'visibilitychange',()=>{
  if(document.hidden){
   ambient?.pause();
   if(root.classList.contains('is-intro'))finish();
  }else startAmbient();
 });
 on(document,'keydown',event=>{
  if(event.key==='Escape'&&root.classList.contains('is-intro'))finish();
 });
 on(reduce,'change',()=>{
  paused=reduce.matches;
  if(paused){
   finish();
   ambient?.pause();
   ambient?.classList.remove('is-visible');
  }else startAmbient();
  motionLabel();
 });

 const formResult=root.querySelector('[data-form-result]');
 if(formResult){
  formResult.focus();
  finish();
 }else if(!location.search.includes('intro=off'))playIntro();
 else finish();

 const countdown=root.querySelector('[data-countdown]');
 if(countdown){
  const fields=Object.fromEntries(
   [...countdown.querySelectorAll('[data-countdown-value]')].map(node=>[node.dataset.countdownValue,node])
  );
  const cycleDays=Math.max(1,Number(countdown.dataset.countdownDays)||18);
  const cycle=cycleDays*24*60*60*1000;
  const parsedAnchor=Date.parse(countdown.dataset.countdownAnchor);
  const anchor=Number.isFinite(parsedAnchor)?parsedAnchor:Date.now();
  const pad=value=>String(value).padStart(2,'0');
  const updateCountdown=()=>{
   const elapsed=((Date.now()-anchor)%cycle+cycle)%cycle;
   let remaining=cycle-elapsed;
   const days=Math.floor(remaining/86400000);
   remaining%=86400000;
   const hours=Math.floor(remaining/3600000);
   remaining%=3600000;
   const minutes=Math.floor(remaining/60000);
   const seconds=Math.floor((remaining%60000)/1000);
   if(fields.days)fields.days.textContent=pad(days);
   if(fields.hours)fields.hours.textContent=pad(hours);
   if(fields.minutes)fields.minutes.textContent=pad(minutes);
   if(fields.seconds)fields.seconds.textContent=pad(seconds);
   countdown.setAttribute('aria-label',`${days} days, ${hours} hours, ${minutes} minutes and ${seconds} seconds until the next opening`);
   countdownTimer=setTimeout(updateCountdown,1020-Date.now()%1000);
  };
  updateCountdown();
 }

 const form=root.querySelector('form');
 const button=form?.querySelector('[type="submit"]');
 const label=form?.querySelector('[data-submit-label]');
 const status=form?.querySelector('[data-form-status]');
 let submitting=false;
 let submissionTimer;

 function busy(value){
  submitting=value;
  form.classList.toggle('is-submitting',value);
  form.setAttribute('aria-busy',String(value));
  if(button){
   button.disabled=value;
   label.textContent=value?'Connecting…':'Keep Me Close';
  }
 }

 function resetSubmission(message){
  clearTimeout(submissionTimer);
  busy(false);
  if(status)status.textContent=message||'';
 }

 on(form,'submit',event=>{
  if(submitting){
   event.preventDefault();
   return;
  }
  busy(true);
  if(status)status.textContent='A thread is bringing us together…';
  submissionTimer=setTimeout(()=>{
   if(submitting)resetSubmission('Please try again.');
  },30000);
  if(root.dataset.demo==='true'){
   event.preventDefault();
   setTimeout(()=>{
    resetSubmission();
    root.querySelector('[data-demo-message]').textContent='Preview only. Your email has not been sent or stored.';
   },900);
  }
 });

 on(window,'pageshow',()=>{
  if(form&&button)resetSubmission();
 });

 root.cleanup=()=>{
  controller.abort();
  clearTimeout(introTimer);
  clearTimeout(countdownTimer);
  clearTimeout(submissionTimer);
  intro?.pause();
  ambient?.pause();
 };
}

document.querySelectorAll('[data-duplex]').forEach(mount);
document.addEventListener('shopify:section:load',event=>{
 event.target.querySelectorAll('[data-duplex]').forEach(mount);
});
document.addEventListener('shopify:section:unload',event=>{
 event.target.querySelectorAll('[data-duplex]').forEach(element=>element.cleanup?.());
});
})();
